module.exports = __webpack_public_path__ + "static/media/active_tick.cdb00061.svg";